/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

export const MANDATE_STATUS_ENDED = 'ended'
export const MANDATE_STATUS_ONGOING = 'ongoing'
export const MANDATE_STATUS_TO_COME_UP = 'to_come_up'

export const MandateStatusCodes = [
  MANDATE_STATUS_ENDED,
  MANDATE_STATUS_ONGOING,
  MANDATE_STATUS_TO_COME_UP
]
